import React, { useState } from 'react';
import Section from '../ui/Section.jsx';
import LogFeedbackModal from '../modals/LogFeedbackModal.jsx';
import FeedbackEntryRow from './FeedbackEntryRow.jsx';
import Pagination, { usePagination } from '../ui/Pagination.jsx';

export default function FeedbackTimeline({ project, entries, onSaved, onDeleted }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing]     = useState(null);
  const { pageItems, ...pager }   = usePagination(entries, 10);

  function openCreate() {
    setEditing(null);
    setModalOpen(true);
  }

  function openEdit(entry) {
    setEditing(entry);
    setModalOpen(true);
  }

  function handleSaved(saved) {
    onSaved(saved, !!editing);
  }

  const headerRight = (
    <button
      onClick={openCreate}
      className="text-[12px] px-2.5 py-1 rounded-md border hover:bg-[#FBFBF8]"
      style={{ borderColor: '#E0DFD9', background: '#fff', color: '#1A1A1A', cursor: 'pointer' }}
    >+ Log entry</button>
  );

  return (
    <>
      <Section id="feedback" title="Feedback & updates" count={`${entries.length} entries`} headerRight={headerRight}>
        {entries.length === 0 ? (
          <div className="text-[12px]" style={{ color: '#9A9A95' }}>No entries yet.</div>
        ) : (
          <>
            <div className="relative pl-6">
              <div style={{ position: 'absolute', left: 8, top: 4, bottom: 4, width: 2, background: '#F0EFE9' }} />
              <ul className="space-y-5">
                {pageItems.map(entry => (
                  <FeedbackEntryRow
                    key={entry.id}
                    entry={entry}
                    onDeleted={onDeleted}
                    onEditRequested={openEdit}
                  />
                ))}
              </ul>
            </div>
            <Pagination {...pager} />
          </>
        )}
      </Section>
      <LogFeedbackModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        projectId={project.id}
        entry={editing}
        onSaved={handleSaved}
      />
    </>
  );
}
